<template>
  <nav
    :class="{
      'menu-open-breadcrumb': isMenuOpen,
      'menu-closed-breadcrumb': !isMenuOpen,
    }"
    class="bread-crumb-nav"
    aria-label="breadcrumb"
    v-if="breadcrumbSegments.length && !breadcrumbSegments[0].hiddenBreadcrumb"
  >
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link class="breadcrumb-navigable" to="/"> Home </router-link>
      </li>
      <li
        v-for="(crumb, index) in breadcrumbSegments"
        :key="index"
        :class="{
          'breadcrumb-item': true,
        }"
        :aria-current="index === breadcrumbSegments.length - 1 ? 'page' : null"
      >
        <a
          v-if="index !== breadcrumbSegments.length - 1"
          :href="crumb.path"
          class="text-capitalize"
          :class="{
            'breadcrumb-navigable': index !== breadcrumbSegments.length - 1,
          }"
        >
          <p class="mb-0">{{ crumb.name }}</p>
        </a>
        <span
          v-else
          class="text-capitalize"
          :class="{
            'active-breadcrumb': index === breadcrumbSegments.length - 1,
          }"
        >
          <p class="mb-0">{{ crumb.name }}</p>
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const route = useRoute();
const store = useStore();
const isMenuOpen = computed(() => store.state.isMenuOpen);

const breadcrumbSegments = computed(() => {
  const currentLang = route.params.lang || "en";
  const currentSkin = route.params.skinFilt || "";

  const languageRegex = /^\/[a-z]{2}(\/|$)/;
  let pathClean = route.path.replace(languageRegex, "");

  if (currentSkin && pathClean.startsWith(currentSkin)) {
    pathClean = pathClean.replace(new RegExp(`^${currentSkin}(\\/|$)`), "");
  }

  return pathClean
    .split("/")
    .filter(Boolean)
    .map((segment, index, segments) => {
      const subPath = segments.slice(0, index + 1).join("/");
      const fullPath = `/${currentLang}${currentSkin ? `/${currentSkin}` : ""}/${subPath}`;
      return {
        name: segment.charAt(0).toUpperCase() + segment.slice(1),
        path: fullPath,
        hiddenBreadcrumb: false,
      };
    });
});

const getRouteIcon = (crumb) => {
  const icons = {
    Login: "/svg/login.svg",
    Home: "/svg/home.svg",
    Bets: "/svg/bet.svg",
    Multiplayers: "/svg/multipliers.svg",
    Wins: "/svg/win.svg",
    Refunds: "/svg/refund.svg",
    Settings: "/svg/settings.svg",
    Messages: "/svg/messages.svg",
    MessagesEdit: "/svg/messages-edit.svg",
    Freebets: "/svg/freebet.svg",
    Create: "/svg/create.svg",
    Logs: "/svg/logs.svg",
    Players: "/svg/players.svg",
    NotFoundPage: "/svg/not-found.svg",
    Skins: "/svg/skins.svg",
  };

  if (crumb.name === "login" || crumb.name === "logout") {
    return icons.Login;
  }

  if (crumb.name === "404") {
    return "/svg/not-found.svg";
  }

  if (!isNaN(crumb.name) || /^[a-f0-9]{24}$/i.test(crumb.name)) {
    return "/svg/folder-open.svg";
  }

  return icons[crumb.name] || "/svg/folder.svg";
};
</script>
